import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX } from '../../../constants';
export const FUNCTION_CONFIG = {
    type: ERFElement.Function,
    icon: 'Function_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 23, left: 6, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 23, right: 6, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFFunctionNode.config.js.map